// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { config } from "@/config/environment";

// Use environment-specific configuration
const SUPABASE_URL = config.database.url;
const SUPABASE_PUBLISHABLE_KEY = config.database.anonKey;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);

// Export constants and helpers for backward compatibility
export { SUPABASE_URL };

export const getSupabaseHeaders = () => ({
  apikey: SUPABASE_PUBLISHABLE_KEY,
  Authorization: `Bearer ${SUPABASE_PUBLISHABLE_KEY}`,
  "Content-Type": "application/json",
});
